import { useTheme } from "../../../context/ThemeContext";
import Cross from "../../../images/Builder/cross.svg";
import CrossDark from "../../../images/Builder/cross_dark.svg";
export const ConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = "Yes, Proceed",
}) => {
  const { theme } = useTheme();
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-[#0000004d] bg-opacity-50 flex items-center justify-center z-50">
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-modalBg p-6 rounded-xl text-center max-w-64">
          <div className="flex flex-col items-center">
            <div className="text-4xl">🤔</div>
            <h3 className="font-medium text-[14px] mt-3 text-n800">{title}</h3>
            <p className="text-[12px] font-medium text-n500 mt-1 max-w-52">
              {message}
            </p>
          </div>
          <div className="flex justify-center gap-3 mt-6">
            <button
              className="border border-n200 px-4 py-2 rounded-lg "
              onClick={onCancel}>
              <img
                src={theme === "dark" ? CrossDark : Cross}
                alt="Execute icon"
                className="w-2 h-2"
              />
            </button>
            <button
              className="bg-swipe-button text-p400 px-4 py-2 rounded-lg w-36 text-sm font-semibold text-[12px] flex items-center justify-center gap-2"
              onClick={onConfirm}>
              <p>{confirmText}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
